const PATH = 'fe.pages.measure.create';

const messages = {
  start: {
    key: `${PATH}.start`,
    defaultValue: 'Create Observation'
  },
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Create {{template}} - {{type}} Observation'
  },
  formal: {
    key: `${PATH}.formal`,
    defaultValue: 'Formal'
  },
  informal: {
    key: `${PATH}.informal`,
    defaultValue: 'Informal'
  },
  informalOptions: {
    key: `${PATH}.informal_options`,
    defaultValue: 'Informal Observation Options'
  },
  enter: {
    key: `${PATH}.enter`,
    defaultValue: 'Enter classroom information'
  },
  fields: {
    date: {
      key: `${PATH}.fields.date`,
      defaultValue: 'Observation Date'
    },
    datePlaceholder: {
      key: `${PATH}.fields.date_placeholder`,
      defaultValue: 'Select a date'
    },
    numberOfCycles: {
      key: `${PATH}.fields.number_of_cycles`,
      defaultValue: 'Number of Cycles'
    },
    numberOfCyclesPlaceholder: {
      key: `${PATH}.fields.number_of_cycles_placeholder`,
      defaultValue: 'Select a number'
    },
    center: {
      key: `${PATH}.fields.center`,
      defaultValue: 'Center'
    },
    centerPlaceholder: {
      key: `${PATH}.fields.center_placeholder`,
      defaultValue: 'Search for an option'
    },
    classroom: {
      key: `${PATH}.fields.classroom`,
      defaultValue: 'Classroom'
    },
    classroomPlaceholder: {
      key: `${PATH}.fields.classroom_placeholder`,
      defaultValue: 'Search for an option'
    },
    educators: {
      key: `${PATH}.fields.educators`,
      defaultValue: 'Educator(s)'
    },
    educatorsPlaceholder: {
      key: `${PATH}.fields.educators_placeholder`,
      defaultValue: 'Separate names with commas'
    },
    observationTool: {
      key: `${PATH}.fields.observation_tool`,
      defaultValue: 'Observation Tool'
    },
    language: {
      key: `${PATH}.fields.language`,
      defaultValue: 'Language'
    },
    jobID: {
      key: `${PATH}.fields.job_id`,
      defaultValue: 'Job ID'
    },
    jobPlaceholder: {
      key: `${PATH}.fields.job_id_placeholder`,
      defaultValue: 'Type the job identifier'
    },
    doubleCoding: {
      key: `${PATH}.fields.double_coding`,
      defaultValue: 'Double Coding Session'
    },
    primaryObserver: {
      key: `${PATH}.fields.primary_observer`,
      defaultValue: 'Primary Observer'
    },
    secondaryObserver: {
      key: `${PATH}.fields.secondary_observer`,
      defaultValue: 'Secondary Observer'
    },
    includesEnvironment: {
      key: `${PATH}.fields.includes_environment`,
      defaultValue: 'Include CLASS Environment'
    },
    gradeLevel: {
      key: `${PATH}.fields.grade_level`,
      defaultValue: 'Grade / Age Level'
    },
    gradeLevelPlaceholder: {
      key: `${PATH}.fields.grade_level_placeholder`,
      defaultValue: 'Select an option'
    },
    timeZone: {
      key: `${PATH}.fields.time_zone`,
      defaultValue: 'Observation Time Zone'
    },
    timeZonePlaceholder: {
      key: `${PATH}.fields.time_zone_placeholder`,
      defaultValue: 'Select a time zone'
    },
    dimensionsOfFocus: {
      key: `${PATH}.fields.dimensions_of_focus`,
      defaultValue: 'Dimension(s) of Focus'
    },
    dimensionsOfFocusPlaceholder: {
      key: `${PATH}.fields.dimensions_of_focus_placeholder`,
      defaultValue: 'Select all that apply'
    },
    dimensionsOfFocusLoading: {
      key: `${PATH}.fields.dimensions_of_focus_loading`,
      defaultValue: 'Loading dimensions...'
    },
    selectAll: {
      key: `${PATH}.fields.select_all`,
      defaultValue: 'Select All'
    },
    clearAll: {
      key: `${PATH}.fields.clear_all`,
      defaultValue: 'Clear All'
    },
    // `selected` rather than `count`, which i18n-js reserves for pluralization
    // and would send the lookup after plural sub-keys that do not exist.
    selectedCount: {
      key: `${PATH}.fields.selected_count`,
      defaultValue: '{{selected}} Selected'
    }
  },
  errors: {
    date: {
      required: {
        key: `${PATH}.errors.date.required`,
        defaultValue: 'Select the date the observation occurred.'
      }
    },
    fieldRequired: {
      key: `${PATH}.errors.field_required`,
      defaultValue: 'This field is required.'
    },
    selectionRequired: {
      key: `${PATH}.errors.selection_required`,
      defaultValue: 'Select at least one option.'
    },
    dimensionsOfFocusRequired: {
      key: `${PATH}.errors.dimensions_of_focus_required`,
      defaultValue: 'Select at least one dimension of focus.'
    }
  },
  warnings: {
    date: {
      past: {
        key: `${PATH}.warnings.date.past`,
        defaultValue: 'Selected date is 1 month or more in the past.'
      }
    },
    educators: {
      no_data: {
        key: `${PATH}.warnings.educators.no_data`,
        defaultValue: 'No educators entered.'
      }
    }
  },
  cancel: {
    key: `${PATH}.cancel`,
    defaultValue: 'Cancel'
  },
  update: {
    key: `${PATH}.update`,
    defaultValue: 'Update Observation'
  },
  delete: {
    key: `${PATH}.delete`,
    defaultValue: 'Delete Observation'
  },
  modal: {
    delete: {
      key: `${PATH}.modal.delete`,
      defaultValue: 'Yes, Delete'
    },
    title: {
      key: `${PATH}.modal.title`,
      defaultValue: 'Delete Observation'
    },
    warning: {
      key: `${PATH}.modal.warning`,
      defaultValue: 'Are you sure you want to delete this observation?'
    }
  },
  removeDimensionsModal: {
    title: {
      key: `${PATH}.remove_dimensions_modal.title`,
      defaultValue: 'Removing Dimension(s) of Focus?'
    },
    warning: {
      key: `${PATH}.remove_dimensions_modal.warning`,
      defaultValue:
        "You've removed one or more dimensions from this observation. Any notes or ranges currently entered for those dimensions will be permanently lost. This can't be undone."
    },
    confirm: {
      key: `${PATH}.remove_dimensions_modal.confirm`,
      defaultValue: 'Update Observation'
    }
  }
};

export default messages;
